import specialApply from "./specialApply";
import specialCardByNoHover from "./specialCardByNoHover";
import personalInforForm from "./personalInforForm";
import specialDetail from "./specialDetail";
export default [
  specialApply, //专题班报名
  specialCardByNoHover, 
  personalInforForm, 
  specialDetail, 
];
